require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-toorak-garden-residence.json") })
        }
      }, "path---project-toorak-garden-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-toorak-garden-residence!./.cache/json/project-toorak-garden-residence.json
// module id = 587
// module chunks = 231608221292675